var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ show: _vm.visible, isBottom: _vm.isBottom },attrs:{"id":"site-scroll"},on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }